export default __webpack_public_path__ + "static/media/lk_brandorodriguez.c8e1ae7f.svg";